import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { MerchSizes } from './constants';
import { buildMerchStoreConfig } from '../storeAliasHelper';
import { data_STAGING } from './STAGING';

export const CyborgClassicTshirtBlackProduct = {
  title: 'Cyborg Classic Black T-shirt',
  description: '100% organic Supima cotton. Made carbon neutral.',
  imgSrc: 'web_v2/all-products/merch/new/cyborg-classic-tee-black.png/w_1920',
  shopifyProductName: 'Cyborg Classic T-shirt',
  availableSizes: [
    MerchSizes.XS,
    MerchSizes.S,
    MerchSizes.M,
    MerchSizes.L,
    MerchSizes.XL,
    MerchSizes.XXL,
  ],
};

export const CyborgClassicTshirtBlackShopifyMap: Record<
  ShopifyStore,
  {
    price: number;
    sizes: Record<MerchSizes, { variantId: string; checkoutUrl: string }>;
  }
> =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? buildMerchStoreConfig<MerchSizes>({
        [ShopifyStore.AE]: {
          price: 110,
          sizes: {
            [MerchSizes.XS]: {
              variantId: 'gid://shopify/ProductVariant/44691321061618',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691321061618:1?channel=buy_button',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/44691321127154',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691321127154:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/44691321192690',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691321192690:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/44691321258226',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691321258226:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/44691321323762',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691321323762:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/44691321389298',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691321389298:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.US]: {
          price: 30,
          sizes: {
            [MerchSizes.XS]: {
              variantId: 'gid://shopify/ProductVariant/40200408596576',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200408596576:1?channel=buy_button',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40200408662112',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200408662112:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40200408727648',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200408727648:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40200408793184',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200408793184:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40200408858720',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200408858720:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40200408924256',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200408924256:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.ROW]: {
          price: 30,
          sizes: {
            [MerchSizes.XS]: {
              variantId: 'gid://shopify/ProductVariant/40718618951740',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718618951740:1?channel=buy_button',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40718619017276',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718619017276:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40718619050044',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718619050044:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40718619082812',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718619082812:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40718619115580',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718619115580:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40718619148348',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718619148348:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.IN]: {
          price: 1699,
          sizes: {
            [MerchSizes.XS]: {
              variantId: 'gid://shopify/ProductVariant/40737950269510',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737950269510:1?channel=buy_button',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40737910194246',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737910194246:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40737910259782',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737910259782:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40737910325318',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737910325318:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40737910390854',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737910390854:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40737910456390',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737910456390:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.EU]: {
          price: 28,
          sizes: {
            [MerchSizes.XS]: {
              variantId: 'gid://shopify/ProductVariant/49202717983038',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202717983038:1?channel=buy_button',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/49202718048574',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202718048574:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/49202718114110',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202718114110:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/49202718179646',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202718179646:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/49202718245182',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202718245182:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/49202718310718',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202718310718:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.GB]: {
          price: 25,
        },
        [ShopifyStore.AU]: {
          price: 45,
        },
        [ShopifyStore.CA]: {
          price: 42,
        },
        [ShopifyStore.MX]: {
          price: 534,
        },
        [ShopifyStore.SA]: {
          price: 109,
        },
        [ShopifyStore.ZA]: {
          price: 599,
        },
        [ShopifyStore.JP]: {
          price: 4800,
        },
      })
    : data_STAGING;
